export default [
	{
		reason_code: 'CTRDDR',
		description:
			'Cross-border settlement conducted for trade in services, including individual bill payments, services or fees relating to transportation; travel; communications; construction services; installation projects and their subcontract services; insurance; financial services; computer and information services; royalties and licence fees; sports and entertainment; water, electricity and gas bills to be paid by corporations or financial institutions; rent; audit fees; hotel accommodation fees; legal fees; advertising and promotion fees; copyright and design fees; research and development fees; company registration fees; medical expenses; government services not mentioned above and other commercial services, etc.',
	},
	{
		reason_code: 'PESRMT',
		description:
			'Outward remittance by an individual customer from Hong Kong to the same name account maintained in the Mainland Inward remittance by an individual customer from the Mainland to the same name account maintained in Hong Kong',
	},
	{
		reason_code: 'BTRDDR',
		description:
			'Cross-border settlement conducted for trade in goods, including individual retail consumptions, general merchandise, goods for processing, goods required for repairing, goods procured in ports by carriers, transactions to be settled by letter of credit, bills for collection, payment of import equipment and advanced payment, etc.',
	},
	{
		reason_code: 'BFTFDR',
		description: 'Cross-border fund transfer between banks',
	},
	{
		reason_code: 'STRDDR',
		description:
			'Capital account transactions, (capital transfers and acquisition/disposal of non-productive or non-financial assets), capital injection, capital reduction, capital payment, direct investments, securities investments, other investments, shareholder�s loan/repayment, other capital payments as approved by relevant regulatory authorities, fund transfers for foreign direct investment (�FDI�) by enterprises and RMB Qualified Foreign Institutional Investor (�RQFII�) projects by enterprises,bonds, fund transfer between enterprises, individual investments, etc.',
	},
];
